// extracted by mini-css-extract-plugin
export default {"userHeader":"styles_userHeader__vSXQW","logo":"styles_logo__xMHqi","title":"styles_title__qV0uU","category":"styles_category__+rwv5"};